import React from "react";
import { Result, Button } from "antd";
import { LockFilled, HomeOutlined } from "@ant-design/icons";

interface UnauthorizedPermissionProps {
  title?: string;
  message?: string;
  showHomeButton?: boolean;
}

const UnauthorizedPermission: React.FC<UnauthorizedPermissionProps> = ({
  title = "Acceso no autorizado",
  message = "No tiene permisos suficientes para realizar esta acción",
  showHomeButton = true,
}) => {
  return (
    <Result
      icon={<LockFilled style={{ color: "#faad14", fontSize: "64px" }} />}
      title={title}
      subTitle={message}
      extra={
        showHomeButton && (
          <Button
            type="primary"
            icon={<HomeOutlined />}
            onClick={() => (window.location.href = "/")}
          >
            Ir al inicio
          </Button>
        )
      }
    />
  );
};

export default UnauthorizedPermission;
